import styled, { css } from "styled-components";
import { floatingPanel } from "../Board/Board.styles";

export const ChatContainer = styled.div<{ $open?: boolean }>`
  position: fixed;
  z-index: ${({ $open }) => ($open ? 20 : 10)};
  top: ${({ $open }) => ($open ? "50%" : "76px")};
  left: ${({ $open }) => ($open ? "50%" : "12px")};
  width: ${({ $open }) => ($open ? "calc(100vw - var(--space-6))" : "auto")};
  max-width: 480px;
  height: ${({ $open }) => ($open ? "min(80vh, 640px)" : "auto")};
  translate: ${({ $open }) => ($open ? "-50% -50%" : "0% 0%")};
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${({ $open }) =>
    $open &&
    css`
      ${floatingPanel}
      animation: pop-in var(--dur-slow) var(--ease-bounce) both;
    `}

  ${({ $open }) => !$open && "overflow: visible;"}
`;

export const ChatHeader = styled.div`
  display: flex;
  gap: var(--space-2);
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
  border-bottom: var(--border-w) dashed var(--line);

  h2 {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    font-size: var(--text-lg);
    font-weight: 600;
  }
`;

export const ChatMessagesList = styled.ul`
  list-style: none;
  padding: var(--space-4);
  margin: 0;
  overflow-y: auto;
  flex: 1;
  background: var(--paper);
  background-image: radial-gradient(var(--paper-dot) 1.2px, transparent 1.2px);
  background-size: 22px 22px;
`;

export const EmptyChat = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-8) var(--space-4);
  text-align: center;
  color: var(--ink-faint);
  font-weight: 700;
`;

export const MessageWrapper = styled.div<{ $sent?: boolean }>`
  display: flex;
  flex-direction: ${({ $sent }) => ($sent ? "row-reverse" : "row")};
  justify-content: flex-start;
  align-items: flex-end;
  padding: 2px 0;
  gap: var(--space-2);
  animation: pop-in var(--dur-base) var(--ease-bounce) both;
`;

export const AnimalContainer = styled.div`
  width: 28px;
  display: flex;
  justify-content: center;
`;

export const MessageContainer = styled.li<{
  $sent?: boolean;
  $isLast?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $sent }) => ($sent ? "flex-end" : "flex-start")};
  gap: 2px;
  flex: 1;
  min-width: 0;
  margin-bottom: ${({ $isLast }) => ($isLast ? "var(--space-2)" : "0")};
`;

export const Message = styled.div<{ $sent?: boolean; $isLast?: boolean }>`
  max-width: 80%;
  padding: var(--space-2) var(--space-3);
  border: var(--border-w) solid ${({ $sent }) => ($sent ? "var(--teal)" : "var(--line-strong)")};
  background: ${({ $sent }) => ($sent ? "var(--teal-tint)" : "var(--card)")};
  color: var(--ink);
  border-radius: var(--radius-lg);
  ${({ $sent, $isLast }) =>
    $isLast &&
    ($sent
      ? "border-bottom-right-radius: var(--radius-sm);"
      : "border-bottom-left-radius: var(--radius-sm);")}
  font-size: var(--text-sm);
  font-weight: 600;
  line-height: 1.4;
  overflow-wrap: anywhere;
`;

export const Author = styled.span<{ $color: string }>`
  display: block;
  font-size: var(--text-xs);
  font-weight: 800;
  color: ${({ $color }) => $color};
`;

export const Time = styled.span`
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--ink-faint);
  padding: 0 var(--space-1);
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: var(--space-3);
  gap: var(--space-2);
  border-top: var(--border-w) dashed var(--line);

  .MuiButton-root {
    min-width: 48px;
    width: 48px;
    padding: 0;
    border-radius: var(--radius-full);
  }
`;

export const TextInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 48px;
  padding: 0 var(--space-4);
  border-radius: var(--radius-full);
  border: var(--border-w) solid var(--line);
  background: var(--card);
  color: var(--ink);
  outline: none;
  font-family: var(--font-body);
  font-weight: 600;
  font-size: var(--text-base);
  transition: border-color var(--dur-fast), box-shadow var(--dur-fast);

  &::placeholder {
    color: var(--ink-faint);
  }

  &:focus {
    border-color: var(--teal);
    box-shadow: 0 0 0 4px var(--teal-tint);
  }
`;
